import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useEffect } from "react";
import { z } from "zod";

import { usePaginatedOffers } from "@/api/offerBank";
import { EditOfferFlow } from "@/features/CouponCodes/EditOfferFlow";

const searchSchema = z.object({
  tab: z.enum(["offer", "targeting", "copy"]).optional().catch(undefined),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/edit/$offerSlug",
)({
  validateSearch: zodValidator(searchSchema),
  component: EditOfferRoute,
});

function EditOfferRoute() {
  const { siteId, offerSlug } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate();

  const { data, isFetching } = usePaginatedOffers(siteId, {
    states: ["active", "inactive"],
    page: 1,
    pageSize: 100,
  });

  const offer = data?.offers.find((o) => o.slug === offerSlug);

  const handleClose = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes",
      params: { siteId },
    });
  };

  // The dialog cannot be closed by the user while empty, so leave instead of
  // showing a blank one when the slug is not in the list. Wait out a refetch
  // first: an offer created a moment ago is not in the cached list yet.
  const missing = data !== undefined && !isFetching && !offer;
  useEffect(() => {
    if (missing) handleClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missing]);

  if (!offer) {
    return null;
  }

  return (
    <EditOfferFlow
      offer={offer}
      siteId={siteId}
      onClose={handleClose}
      initialTab={tab}
    />
  );
}
